<div
  ngbDropdown
  autoClose="outside"
  [class.d-block]="appearance() === 'button'"
  [class.form-floating]="appearance() === 'form-control'"
>
  @if (appearance() === 'button') {
    <button
      type="button"
      class="btn btn-outline-primary w-100 d-flex"
      id="multi-select"
      ngbDropdownToggle
      [disabled]="isDisabled()"
    >
      <span class="flex-grow-1 text-truncate">
        {{ selectedOptions() || (placeholder() || 'component.multi-select.placeholder' | translate) }}
      </span>

      <fa-icon [icon]="'chevron-down'" class="ms-1"></fa-icon>
    </button>
  } @else {
    <button
      type="button"
      class="form-select text-start text-truncate"
      [class.has-value]="hasValue()"
      id="multi-select"
      ngbDropdownToggle
      [disabled]="isDisabled()"
    >
      {{ selectedOptions() }}
    </button>

    <label for="multi-select" class="form-label">
      {{ placeholder() || 'component.multi-select.placeholder' | translate }}
    </label>
  }

  <div ngbDropdownMenu aria-labelledby="multi-select" class="w-100">
    @for (option of options(); track option.value) {
      <div ngbDropdownItem [class.active]="option.selected" class="p-0">
        <div class="form-check p-0">
          <label for="check_{{ option.value }}" class="w-100 p-2">
            <input
              class="form-check-input ms-0 me-2"
              type="checkbox"
              value=""
              id="check_{{ option.value }}"
              [checked]="option.selected"
              (change)="onOptionToggle(option)"
              [disabled]="isDisabled() || option.disabled"
            />
            <span class="form-check-label">
              {{ option.label }}
            </span>
          </label>
        </div>
      </div>
    }
  </div>
</div>
